import styled from 'styled-components';

interface JiraStatusProps{
  status: string;
}

const StatusContainer = styled.span`
  background: #F3F6F8;
  border-radius: 4px;
  padding: 2px 7px;
  display: inline-block;
  font-size: 14px;
  font-family: OpenSans, sans-serif;
  color: #505050;
  
  &.on-hold, &.in-review, &.in-progress{
    color: #0039BB;
    background-color: #CADFFC;
  }
  &.done{
    background-color: #219653;
    color: #fff;
  }
`;

const JiraStatus = ({ status }: JiraStatusProps ) => {
  const statusClass = status.toLowerCase().split(' ').join('-');
  return (
    <StatusContainer className={statusClass}>
      {status.toUpperCase()}
    </StatusContainer>
  )
}

export default JiraStatus;